import { render, staticRenderFns } from "./ModelRSQUAREDiv.vue?vue&type=template&id=3a3242cf&scoped=true&"
import script from "./ModelRSQUAREDiv.vue?vue&type=script&lang=js&"
export * from "./ModelRSQUAREDiv.vue?vue&type=script&lang=js&"
import style0 from "./ModelRSQUAREDiv.vue?vue&type=style&index=0&id=3a3242cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3242cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VIcon})
